/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserManager } from './UserManager';
import {
    UserManagerFromJSON,
    UserManagerFromJSONTyped,
    UserManagerToJSON,
} from './UserManager';

/**
 * 
 * @export
 * @interface ManagersResponse
 */
export interface ManagersResponse {
    /**
     * 
     * @type {Array<UserManager>}
     * @memberof ManagersResponse
     */
    data?: Array<UserManager>;
}

/**
 * Check if a given object implements the ManagersResponse interface.
 */
export function instanceOfManagersResponse(value: object): value is ManagersResponse {
    let isInstance = true;

    return isInstance;
}

export function ManagersResponseFromJSON(json: any): ManagersResponse {
    return ManagersResponseFromJSONTyped(json, false);
}

export function ManagersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserManagerFromJSON)),
    };
}

export function ManagersResponseToJSON(value?: ManagersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserManagerToJSON)),
    };
}

